export class BeanMonitoryFiles { 
    constructor(
        public moniIdCdMonitoria: string,
        public moanDsArquivo: string,
        public moanDsNomeArquivo: string,
        public moanIdCdMonitoriaAnexo: string,
        public moanDhRegistro: string
        
    ){} 
}